var map = {
	"./bursa.png": 359,
	"./fabric-type-cotton.png": 131,
	"./fabric-type-linen.png": 820,
	"./fabric-type-twill.png": 540,
	"./gots.jpg": 210,
	"./ics.png": 552,
	"./iso.jpg": 171,
	"./munchen.png": 943,
	"./ocs.png": 466,
	"./oeko.png": 445,
	"./paris.png": 886,
	"./rcs.jpg": 919,
	"./shirt-image.jpg": 623,
	"./tekstas-logo.svg": 880,
	"./tekstas.jpg": 310,
	"./tekstaslogo.png": 463,
	"./textile-bg-2.png": 315,
	"./textile-bg.png": 706,
	"./textile-image-1.png": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;